import script from "./TextButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TextButton.vue?vue&type=script&setup=true&lang=js"

import "./TextButton.vue?vue&type=style&index=0&id=25da5e22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25da5e22"]])

export default __exports__